'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const ReactDOM = _interopDefault(require('react-dom'));
const scrollLock = require('../ScrollLock/scrollLock.js');
const useControlledState = require('../hooks/useControlledState/useControlledState.js');
const scrollbarWidthOffset = require('../ScrollbarWidthOffset/scrollbarWidthOffset.js');
const backdrop = require('../Modal/Backdrop/backdrop.js');
const popover_types = require('./popover.types.js');
const popover_style = require('./popover.style.js');
const popperComponent = require('./popperComponent.js');

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DEFAULT_DATA_ATTR = {
  'data-testid': 'popover__backdrop'
};
var Popover = function Popover(props) {
  var _props$showMultiple = props.showMultiple,
    showMultiple = _props$showMultiple === void 0 ? false : _props$showMultiple,
    _props$showOnEvent = props.showOnEvent,
    showOnEvent = _props$showOnEvent === void 0 ? popover_types.ShowOnEvent.CLICK : _props$showOnEvent,
    children = props.children,
    portalTarget = props.portalTarget,
    onOpen = props.onOpen,
    onClose = props.onClose,
    _props$closeOnPopperC = props.closeOnPopperClick,
    closeOnPopperClick = _props$closeOnPopperC === void 0 ? true : _props$closeOnPopperC,
    isOpen = props.isOpen,
    _props$defaultIsOpen = props.defaultIsOpen,
    defaultIsOpen = _props$defaultIsOpen === void 0 ? false : _props$defaultIsOpen,
    _props$preventOverflo = props.preventOverflow,
    preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
    _props$overflowOverRe = props.overflowOverReference,
    overflowOverReference = _props$overflowOverRe === void 0 ? false : _props$overflowOverRe,
    _props$flipPopover = props.flipPopover,
    flipPopover = _props$flipPopover === void 0 ? true : _props$flipPopover,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    _props$BackdropCompon = props.BackdropComponent,
    BackdropComponent = _props$BackdropCompon === void 0 ? backdrop : _props$BackdropCompon,
    backdropProps = props.backdropProps,
    _props$enableBackdrop = props.enableBackdropClick,
    enableBackdropClick = _props$enableBackdrop === void 0 ? false : _props$enableBackdrop,
    _props$enableScrollba = props.enableScrollbarWidthOffset,
    enableScrollbarWidthOffset = _props$enableScrollba === void 0 ? false : _props$enableScrollba,
    _props$enableScrollLo = props.enableScrollLock,
    enableScrollLock = _props$enableScrollLo === void 0 ? false : _props$enableScrollLo,
    _props$enableBackdrop2 = props.enableBackdrop,
    enableBackdrop = _props$enableBackdrop2 === void 0 ? false : _props$enableBackdrop2,
    popoverOffset = props.popoverOffset,
    preventOverflowPadding = props.preventOverflowPadding,
    placement = props.placement,
    popoverContent = props.popoverContent,
    theme = props.theme,
    className = props.className;
  var _useControlledState = useControlledState({
      controlled: isOpen,
      "default": defaultIsOpen,
      name: 'Popover'
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    isPopoverOpen = _useControlledState2[0],
    setIsPopoverOpen = _useControlledState2[1];
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    refElement = _useState2[0],
    setRefElement = _useState2[1];
  var openPopover = React.useCallback(function () {
    setIsPopoverOpen(true);
    if (onOpen) {
      onOpen();
    }
  }, [setIsPopoverOpen, onOpen]);
  var closePopover = React.useCallback(function () {
    setIsPopoverOpen(false);
    if (onClose) {
      onClose();
    }
  }, [setIsPopoverOpen, onClose]);
  var clickOutsidePopperHandler = React.useCallback(function () {
    var couldClose = !showMultiple && isPopoverOpen;
    if (couldClose) {
      closePopover();
    }
  }, [showMultiple, isPopoverOpen, closePopover]);
  var togglePopover = React.useCallback(function () {
    if (isPopoverOpen) {
      closePopover();
    } else {
      openPopover();
    }
  }, [isPopoverOpen, closePopover, openPopover]);
  var clickHandlers = {
    onClick: function onClick() {
      return togglePopover();
    }
  };
  var hoverHandlers = {
    onMouseEnter: openPopover,
    onMouseLeave: closePopover
  };
  var onBackdropClick = React.useCallback(function () {
    if (enableBackdropClick) {
      closePopover();
    }
  }, [enableBackdropClick, closePopover]);
  var hasDocument = (typeof document === "undefined" ? "undefined" : _typeof(document)) !== undefined;
  var isShowingBackdrop = isPopoverOpen && enableBackdrop;
  var popper = /*#__PURE__*/React__default.createElement(popover_style.PopperContainer, {
    isShowingBackdrop: isShowingBackdrop
  }, enableScrollbarWidthOffset && /*#__PURE__*/React__default.createElement(scrollbarWidthOffset, null), enableScrollLock && /*#__PURE__*/React__default.createElement(scrollLock.default, null), enableBackdrop && /*#__PURE__*/React__default.createElement(BackdropComponent, _extends({
    dataAttr: DEFAULT_DATA_ATTR,
    onClick: onBackdropClick
  }, backdropProps)), /*#__PURE__*/React__default.createElement(popperComponent, {
    referenceElement: refElement,
    clickOutsidePopperHandler: clickOutsidePopperHandler,
    popperClickHandler: closeOnPopperClick ? closePopover : undefined,
    preventOverflow: preventOverflow,
    overflowOverReference: overflowOverReference,
    flipPopover: flipPopover,
    showArrow: showArrow,
    popoverOffset: popoverOffset,
    preventOverflowPadding: preventOverflowPadding,
    placement: placement,
    popoverContent: popoverContent,
    theme: theme,
    className: className
  }));
  var popperElement = portalTarget && hasDocument ? /*#__PURE__*/ReactDOM.createPortal(popper, portalTarget) : popper;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(popover_style.ReferenceWrapper, _extends({}, showOnEvent === popover_types.ShowOnEvent.CLICK ? clickHandlers : hoverHandlers, {
    ref: setRefElement,
    isShowingBackdrop: isShowingBackdrop
  }), children), isPopoverOpen ? popperElement : null);
};
const popover = styled.withTheme(Popover);

module.exports = popover;
